import { render, staticRenderFns } from "./SetUserPassword.vue?vue&type=template&id=80f92cd6"
import script from "./SetUserPassword.vue?vue&type=script&lang=js"
export * from "./SetUserPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports